import './Upload.css';
import { useState, useRef } from 'react';
import SERVER_URL from '../../../../env.js';
import { papaParseCSV, getParsedReturnsObjects } from '../../../../Utils/FileUtil.js';
import Cookies from 'js-cookie';

const TITLE_OPTIONS = ['', 'Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Prof.', 'Other'];
const MARITAL_OPTIONS = ['', 'Single', 'Married', 'Common-Law', 'Divorced', 'Widowed'];

function Upload({ toggleNav, closeCreateModal, setClients }) {
    const [firstName, setFirstName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [notes, setNotes] = useState('');
    const [authRep, setAuthRep] = useState(false);
    const [myCRA, setMyCRA] = useState(false);
    const [parsedClients, setParsedClients] = useState([]);
    const [updateMessage, setUpdateMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const fileInputRef = useRef(null);
    const [chosenFile, setChosenFile] = useState(null);

    // Additional fields
    const [showAdditionalFields, setShowAdditionalFields] = useState(false);
    const [sin, setSin] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [address_street, setAddressStreet] = useState('');
    const [address_city, setAddressCity] = useState('');
    const [address_province, setAddressProvince] = useState('');
    const [address_postal, setAddressPostal] = useState('');
    const [address_country, setAddressCountry] = useState('');
    const [title, setTitle] = useState('');
    const [citizenshipStatus, setCitizenshipStatus] = useState(false);
    const [maritalStatus, setMaritalStatus] = useState('');
    const [spouseName, setSpouseName] = useState('');
    const [language, setLanguage] = useState('english');

    const formatPostalCode = (postalCode) => {
        if (!postalCode) return ''
        postalCode = postalCode.replace(/\s/g, '')
        if (postalCode.length !== 6) return postalCode.toUpperCase()
        return postalCode.toUpperCase().replace(/([A-Z])([0-9])([A-Z])([0-9])([A-Z])([0-9])/g, '$1$2$3 $4$5$6')
    }

    const formatPhone = (phone) => {
        if (!phone) return ''
        phone = phone.replace(/\D/g, '')
        if (phone.length !== 10) return phone
        return phone.replace(/([0-9]{3})([0-9]{3})([0-9]{4})/g, '($1) $2-$3')
    }
    const handleFirstNameChange = (event) => setFirstName(event.target.value);
    const handleMiddleNameChange = (event) => setMiddleName(event.target.value);
    const handleLastNameChange = (event) => setLastName(event.target.value);
    const handlePhoneChange = (event) => setPhone(formatPhone(event.target.value));
    const handleEmailChange = (event) => setEmail(event.target.value);
    const handleNotesChange = (event) => setNotes(event.target.value);
    const handleAuthRepChange = (event) => setAuthRep(event.target.value);
    const handleMyCRAChange = (event) => setMyCRA(event.target.value);


    const getAddressString = () => {
        // get address parts from the useState and format them correctly into a full address string
        let address_string = ''
        if (address_street) address_string += address_street;
        if (address_city) address_string += ', ' + address_city;
        if (address_province) address_string += ', ' + address_province;
        if (address_postal) address_string += ', ' + formatPostalCode(address_postal);
        if (address_country) address_string += ', ' + address_country;

        return address_string;
    };

    const showSpouseName = showAdditionalFields &&
        (maritalStatus === 'Married' || maritalStatus === 'Common-Law');

    const handleClientFile = (event) => {
        const file = event.target.files[0]
        if (!file) return
        setChosenFile(file)
        const fileExtension = file.name.split('.').pop().toLowerCase()
        const fileType = file.type || null
        if (!fileExtension.includes('csv') && (!fileType || !fileType.includes('csv'))) {
            alert('Please upload a .csv file type.')
            return
        }
        const fileReader = new FileReader()
        fileReader.onload = (event) => {
            const text = event.target.result
            if (text) {
                setParsedClients(papaParseCSV(text))
            }
        }
        fileReader.readAsText(file)
    }

    const handleFileUpload = () => {
        const fileExtension = chosenFile.name.split('.').pop().toLowerCase()
        const fileType = chosenFile.type || null
        if (!fileExtension.includes('csv') && (!fileType || !fileType.includes('csv'))) {
            return { error: 'Please upload a .csv file type.' }
        }
        if (!parsedClients || parsedClients.length === 0) {
            return { error: 'No clients found in the file.' }
        }

        const { clients, _ } = getParsedReturnsObjects(parsedClients);
        fetch(SERVER_URL + '/bulk/bulk-upload', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Cookies.get('accessToken'),
            },
            body: JSON.stringify({
                clients: clients
            }),
        })
            .then(async (response) => {
                if (!response.ok) {
                    const errData = await response.json().catch(() => ({}));
                    throw new Error(errData.error || errData.message || `HTTP error ${response.status}`);
                }
                const data = await response.json();
                setUpdateMessage(prev => prev + `\n Successfully created ${data.clients.length} clients from ${chosenFile.name}.`);
                setClients(prev => [...prev, ...data.clients]);
                closeCreateModal();
            })
            .catch((error) => {
                setErrorMessage(prev => prev + `\n Error uploading file. ${error.message}`);
            });
    }

    const handleUpload = () => {
        if (chosenFile) {
            const result = handleFileUpload();
            if (result?.error) {
                setErrorMessage(prev => prev + ' \n ' + result.error)
                return;
            }
        }
        if (!firstName.trim() || !lastName.trim() || !email.trim()) {
            // Need at least name and email
            return;
        }

        console.log('phone and address', phone, getAddressString())

        fetch(SERVER_URL + '/clients', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Cookies.get('accessToken'),
            },
            body: JSON.stringify({
                firstName: firstName,
                middleName: middleName,
                lastName: lastName,
                phone: phone,
                email: email,
                notes: notes,
                auth_rep: authRep,
                my_cra: myCRA,
                sin: sin || null,
                date_of_birth: dateOfBirth || null,
                address: getAddressString() || null,
                title: title || null,
                citizenship_status: citizenshipStatus,
                marital_status: maritalStatus || null,
                spouse_name: spouseName || null,
                language: language || 'english',
            }),
        })
            .then(async (response) => {
                if (!response.ok) {
                    const errData = await response.json().catch(() => ({}));
                    throw new Error(errData.error || errData.message || `HTTP error ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                setUpdateMessage(prev => prev + '\n Client uploaded successfully');
                setClients(prev => [...prev, data.client]);
                closeCreateModal();
            })
            .catch((error) => {
                setErrorMessage(prev => prev + ' \n' + ' Error uploading client: ' + error.message);
            });
    };

    return (
        <div className="Upload">
            {updateMessage && <p className="update-message">{updateMessage}</p>}
            {errorMessage && <p className="error-message">{errorMessage}</p>}
            <div className="upload-container">
                <div className="upload-primary-grid">
                    <div className="upload-field-group">
                        <label className="upload-field-label">First Name &nbsp;<span className="required">*</span></label>
                        <input className="upload-text-input" type="text" id="firstName" onChange={handleFirstNameChange} placeholder="First Name..." />
                    </div>
                    <div className="upload-field-group">
                        <label className="upload-field-label">Middle Name</label>
                        <input className="upload-text-input" type="text" id="middleName" onChange={handleMiddleNameChange} placeholder="Middle Name..." />
                    </div>
                    <div className="upload-field-group">
                        <label className="upload-field-label">Last Name &nbsp;<span className="required">*</span></label>
                        <input className="upload-text-input" type="text" id="lastName" onChange={handleLastNameChange} placeholder="Last Name..." />
                    </div>
                    <div className="upload-field-group">
                        <label className="upload-field-label">Phone</label>
                        <input className="upload-text-input" type="text" id="phone" onChange={handlePhoneChange} placeholder="Phone..." />
                    </div>
                    <div className="upload-field-group">
                        <label className="upload-field-label">Email &nbsp;<span className="required">*</span></label>
                        <input className="upload-text-input" type="email" id="email" onChange={handleEmailChange} placeholder="Email..." />
                    </div>

                    <div className="modal-row" style={{ width: '80%' }}>
                        <div className="modal-col">
                            <label className="upload-field-label">My CRA</label>
                            <div className="upload-language-toggle">
                                <button
                                    type="button"
                                    className={`upload-lang-btn${myCRA === true ? ' upload-lang-btn--active' : ''}`}
                                    onClick={() => handleMyCRAChange({ target: { name: 'my_cra', value: true } })}
                                >
                                    Yes
                                </button>
                                <button
                                    type="button"
                                    className={`upload-lang-btn${myCRA === false ? ' upload-lang-btn--active' : ''}`}
                                    onClick={() => handleMyCRAChange({ target: { name: 'my_cra', value: false } })}
                                >
                                    No
                                </button>
                            </div>
                        </div>

                        <div className="modal-col">
                            <label className="upload-field-label">Authorized Representative</label>
                            <div className="upload-language-toggle">
                                <button
                                    type="button"
                                    className={`upload-lang-btn${authRep === true ? ' upload-lang-btn--active' : ''}`}
                                    onClick={() => handleAuthRepChange({ target: { name: 'auth_rep', value: true } })}
                                >
                                    Yes
                                </button>
                                <button
                                    type="button"
                                    className={`upload-lang-btn${authRep === false ? ' upload-lang-btn--active' : ''}`}
                                    onClick={() => handleAuthRepChange({ target: { name: 'auth_rep', value: false } })}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="upload-question-container">
                    <label className="upload-field-label">Notes</label>
                    <textarea className="upload-textarea-input" rows={5} onChange={handleNotesChange} placeholder="Notes..." />

                    <input ref={fileInputRef} type="file" onChange={handleClientFile} style={{ display: 'none' }} accept=".csv" />
                    <div className="file-upload" onClick={() => fileInputRef.current.click()}>
                        {chosenFile?.name || 'Choose CSV File'}
                    </div>
                </div>

                {/* Additional Fields Toggle */}
                <div className="upload-additional-toggle">
                    <label className="upload-toggle-label">
                        <input
                            type="checkbox"
                            className="upload-toggle-checkbox"
                            checked={showAdditionalFields}
                            onChange={(e) => setShowAdditionalFields(e.target.checked)}
                        />
                        <span className="upload-toggle-text">Additional Fields</span>
                    </label>
                </div>

                {/* Additional Fields Section */}
                {showAdditionalFields && (
                    <div className="upload-additional-fields">
                        <div className="upload-additional-grid">
                            {/* Title */}
                            <div className="upload-field-group">
                                <label className="upload-field-label">Title</label>
                                <select
                                    className="upload-select-input"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                >
                                    {TITLE_OPTIONS.map(opt => (
                                        <option key={opt} value={opt}>{opt || '— Select —'}</option>
                                    ))}
                                </select>
                            </div>

                            {/* SIN */}
                            <div className="upload-field-group">
                                <label className="upload-field-label">SIN</label>
                                <input
                                    className="upload-text-input"
                                    type="text"
                                    value={sin}
                                    onChange={(e) => setSin(e.target.value)}
                                    placeholder="Social Insurance Number..."
                                />
                            </div>

                            {/* Date of Birth */}
                            <div className="upload-field-group">
                                <label className="upload-field-label">Date of Birth</label>
                                <input
                                    className="upload-text-input"
                                    type="date"
                                    value={dateOfBirth}
                                    onChange={(e) => setDateOfBirth(e.target.value)}
                                />
                            </div>

                            {/* Marital Status */}
                            <div className="upload-field-group">
                                <label className="upload-field-label">Marital Status</label>
                                <select
                                    className="upload-select-input"
                                    value={maritalStatus}
                                    onChange={(e) => setMaritalStatus(e.target.value)}
                                >
                                    {MARITAL_OPTIONS.map(opt => (
                                        <option key={opt} value={opt}>{opt || '— Select —'}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Spouse Name (conditional) */}
                            {showSpouseName && (
                                <div className="upload-field-group">
                                    <label className="upload-field-label">Spouse Name</label>
                                    <input
                                        className="upload-text-input"
                                        type="text"
                                        value={spouseName}
                                        onChange={(e) => setSpouseName(e.target.value)}
                                        placeholder="Spouse / Partner Name..."
                                    />
                                </div>
                            )}

                            {/* Address */}

                            <div className="upload-field-group">
                                <label className="upload-field-label">Street</label>
                                <input
                                    className="upload-text-input"
                                    type="text"
                                    value={address_street}
                                    onChange={(e) => setAddressStreet(e.target.value)}
                                    placeholder="Street Address..."
                                />
                            </div>
                            <div className="upload-field-group">
                                <label className="upload-field-label">City</label>
                                <input
                                    className="upload-text-input"
                                    type="text"
                                    value={address_city}
                                    onChange={(e) => setAddressCity(e.target.value)}
                                    placeholder="City..."
                                />
                            </div>
                            <div className="upload-field-group">
                                <label className="upload-field-label">Province</label>
                                <input
                                    className="upload-text-input"
                                    type="text"
                                    value={address_province}
                                    onChange={(e) => setAddressProvince(e.target.value)}
                                    placeholder="Province/Territory/State..."
                                />
                            </div>
                            <div className="upload-field-group">
                                <label className="upload-field-label">Postal Code</label>
                                <input
                                    className="upload-text-input"
                                    type="text"
                                    value={address_postal}
                                    onChange={(e) => setAddressPostal(e.target.value)}
                                    placeholder="Postal Code/ZIP Code..."
                                />
                            </div>
                            <div className="upload-field-group">
                                <label className="upload-field-label">Country</label>
                                <input
                                    className="upload-text-input"
                                    type="text"
                                    value={address_country}
                                    onChange={(e) => setAddressCountry(e.target.value)}
                                    placeholder="Country..."
                                />
                            </div>

                            {/* Language */}
                            <div className="upload-field-group">
                                <label className="upload-field-label">Language</label>
                                <div className="upload-language-toggle">
                                    <button
                                        type="button"
                                        className={`upload-lang-btn${language === 'english' ? ' upload-lang-btn--active' : ''}`}
                                        onClick={() => setLanguage('english')}
                                    >
                                        English
                                    </button>
                                    <button
                                        type="button"
                                        className={`upload-lang-btn${language === 'french' ? ' upload-lang-btn--active' : ''}`}
                                        onClick={() => setLanguage('french')}
                                    >
                                        French
                                    </button>
                                </div>
                            </div>

                            {/* Citizenship Status */}
                            <div className="upload-field-group upload-field-group--checkbox">
                                <label className="upload-toggle-label">
                                    <input
                                        type="checkbox"
                                        className="upload-toggle-checkbox"
                                        checked={citizenshipStatus}
                                        onChange={(e) => setCitizenshipStatus(e.target.checked)}
                                    />
                                    <span className="upload-toggle-text">Canadian Citizen</span>
                                </label>
                            </div>
                        </div>
                    </div>
                )}

                <button className="upload-submit" onClick={handleUpload}>Create Client</button>
            </div>
        </div>
    );
}

export default Upload;
